import { ActionTypes } from './constants';
import * as Models from './models';

export const addScreen: Models.ActionCreator.AddScreen = arg => ({
  type: ActionTypes.ADD_SCREEN,
  payload: arg,
});
